// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + (chunkId === 6730 ? "lazy-actions" : chunkId) + ".chunk.min.js";
};